const UNITS = ["B", "KB", "MB", "GB", "TB"];

/* Convierte un tamaño en bytes a un texto legible (ej. 1073741824 -> "1 GB") */
export function formatBytes(bytes) {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return "";
  if (bytes === 0) return "0 B";

  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1
  );
  const value = bytes / Math.pow(1024, exponent);
  const rounded = Math.round(value * 100) / 100;

  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(2)} ${UNITS[exponent]}`;
}
